import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SourceIconsComponent } from './source-icons.component';
import { MatButtonModule } from '@angular/material/button';
import { WalletListMenuComponent } from './wallet-list-menu/wallet-list-menu.component';
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { StaticPagesService } from '../Services/static-pages.service';
import { LazyMapsAPILoaderConfigLiteral } from '@agm/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { CompareListMenuComponent } from './compare-list-menu/compare-list-menu.component';
import { StarsListMenuComponent } from './stars-list-menu/stars-list-menu.component';
import { LoadingModule } from '../Global/loading/loading.module';
var initialApiKey = "";
/********** Custom option for ngx-translate ******/
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
export function agmConfigFactory(
    configData: StaticPagesService,
    config: LazyMapsAPILoaderConfigLiteral
) {
    return () =>
        configData.getenvConfig().subscribe((res) => {
            if (res) {
                initialApiKey = res?.GOOGLE_MAP_API_KEY;
                config.apiKey = res?.GOOGLE_MAP_API_KEY;
                return res;
            }
        });
}

@NgModule({
  declarations: [
      SourceIconsComponent,
      WalletListMenuComponent,
      CompareListMenuComponent,
      StarsListMenuComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
      MatIconModule,
      MatMenuModule,
      RouterModule,
        LoadingModule,
     TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
  ],
  exports:[
  SourceIconsComponent,
  WalletListMenuComponent,
  CompareListMenuComponent,
  StarsListMenuComponent,

  TranslateModule,

]
})
export class SourceIconsModule { }
